/* globals document */
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'proxy-polyfill';
import 'babel-polyfill';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { init as initFullStory, isInitialized } from '@fullstory/browser';
import { flushFSPendingEvents } from './fullstory';
// import registerServiceWorker from './registerServiceWorker';
import './index.css';
import { getZ3PConfiguration } from './brainApi';
import { storeZ3PConfiguration } from './helper';

const ENV = process.env.REACT_APP_DATA_PROVIDER;
const prod_envs = ['prod', 'production'];
if (prod_envs.includes(ENV)) {
  if (window && window.rudderanalytics) {
    window.rudderanalytics.load(
      process.env.REACT_APP_RUDDER_STACK_PROD_WRITE_KEY,
      process.env.REACT_APP_RUDDER_STACK_DATA_PLANE_URL,
    );

    // Track initial page load
    window.rudderanalytics.page();
  } else {
    console.warn("rudderanalytics not found on window, check if CDN is loaded correctly");
  }
}
initFullStory({
  orgId: 'Q1WHG',
  // REQUIRED: Tells the iFrame to capture its content and send it to the host
  recordCrossDomainIFrames: true,
  debug: true,
});

// Flush any queued FullStory events after initialization
flushFSPendingEvents();

const staging_envs = ['dev', 'staging', 'test'];
if (staging_envs.includes(ENV)) {
  // Check if rudderanalytics is available on window
  if (window && window.rudderanalytics) {
    window.rudderanalytics.load(
      process.env.REACT_APP_RUDDER_STACK_STAGE_WRITE_KEY,
      process.env.REACT_APP_RUDDER_STACK_DATA_PLANE_URL,
    );

    // Track initial page load
    window.rudderanalytics.page();
  } else {
    console.warn("rudderanalytics not found on window, check if CDN is loaded correctly");
  }
}

getZ3PConfiguration().then((z3pConfiguration) => {
  storeZ3PConfiguration(z3pConfiguration);
  ReactDOM.render(<App />, document.getElementById('root'));

  // Mar 2022:
  // This service worker was originally intended to let you access some Admin Portal pages while offline.
  // (It is only called in Production, not in localhost or Staging.)
  // But we have customized react-admin with our own API calls, and this offline mode isn't working.
  // Also, it relies on a PUBLIC_URL environment variable, and with multitenancy we will not be able to
  // pass this environment variable because we have a single Cloudfront distribution for many URLs.
  // Therefore, we are taking this out for now.  We may decide to add it back in the future, but it will
  // take some work to enable offline mode.
  // registerServiceWorker();
});
